import { createI18n } from "vue-i18n";

import de from "@/locales/de.json";
import en from "@/locales/en.json";

export const locale = window.navigator.language || "en";
export const localeNoRegion = locale.split("-")[0];

const datetimeFormats = {
  en: {
    short: {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    },
    long: {
      year: "numeric",
      month: "long",
      day: "numeric",
    },
    datetime: {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "numeric",
      minute: "numeric",
    },
  },
  de: {
    short: {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    },
    long: {
      year: "numeric",
      month: "long",
      day: "numeric",
    },
    datetime: {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "numeric",
      minute: "numeric",
    },
  },
} as const;

export default createI18n({
  globalInjection: true,
  legacy: false,
  locale: localeNoRegion,
  fallbackLocale: "en",
  datetimeFormats,
  messages: {
    de,
    en,
  },
});
